import { createSlice, EntityId } from '@reduxjs/toolkit';

export interface AssetInterface {
  id: number;
  name: string;
  pro: number;
  type: string;
  thumbnail_url: string;
  category_id: number | undefined;
  subcategory_id: number | undefined;
}

export interface AssetsInterface {
  [key: string]: AssetInterface
}

export interface initialInterface {
  error: string | null;
  loading: boolean;
  entities: AssetsInterface | null;
  ids: EntityId[];
}

const initialState: initialInterface = {
  error: null,
  loading: false,
  entities: null,
  ids: []
};

const assetsSlice = createSlice({
  name: 'assets',
  initialState,
  reducers: {
    setIds(state, action) {
      state.ids = action.payload;
    },
    setAssets(state, action) {
      state.entities = action.payload;
    },
    clearAssets(state) {
      state.entities = initialState.entities;
      state.ids = initialState.ids;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    }
  }
});

export const {
  setLoading,
  setError,
  setIds,
  setAssets,
  clearAssets
} = assetsSlice.actions;

export default assetsSlice.reducer;
